'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Overbooking', []).factory('OverbookingService', require('./services/OverbookingService'));